export default Object.freeze({
  ACTION_TYPE: 'action_type',
  ACTOR_EMAIL: 'actor_email',
  ACTOR_ID: 'actor_id',
  ACTOR_TYPE: 'actor_type',
  APPLICATION_NAME: 'application_name',
  CLIENT_ID: 'client_id',
  CREATION_PERIOD: 'creation_period',
  COMPLETION_PERIOD: 'completion_period',
  TAGS: 'tags',
  TARGET_TYPE: 'target_type',
  TARGET_REFERENCE: 'target_reference',
  TARGET_ID: 'target_id',
  TRANSACTION_ID: 'transaction_id',
  IS_BULK: 'is_bulk',
  ENTITY_TYPE: 'entity_type',
  ENTITY_ID: 'entity_id',
});
